import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IContact } from './Contacts.types';

@Identifiable
@Timestampable
@Untrackable
export class Contact extends AbstractDocument<IContact> {
  readonly collections = {};
}

export class Contacts extends AbstractCollection<Contact, IContact> {
  static path = 'contacts';

  constructor(document: Supplier) {
    super(document.collection(Contacts.path), Contact);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
